<template>
<span class="profile-badge">
  <img class="avatar" v-if="logo_data.logo_thumb" v-b-tooltip.hover :disabled="tooltipDisabled" :src="logo_data.logo_thumb" :title="logo_data.name">
  <span class="no-avatar" v-if="!logo_data.logo_thumb && !defaultAvatar" v-b-tooltip.hover :disabled="tooltipDisabled" :title="logo_data.name">{{ logo_data.initials }}</span>
  <span v-if="defaultAvatar"><font-awesome-icon icon="fa-solid fa-user" /></span>
</span>
</template>
<script>
    import BrandService from "@/store/services/brand.service.js";

    export default {
        name: "LogoBrand",
        props: {
            brandId: Number,
            companyLogo: {
                type: Object,
                default: () => {}
            },
            tooltipDisabled: {
                type: Boolean,
                default: false
            },
            defaultAvatar: {
                type: Boolean,
                default: false
            },
        },
        components: {},
        data () {
            return {
                logo_data: {}
            }
        },
        created () {
            if (this.brandId) {
                BrandService.logo(this.brandId).then((response) => {
                    this.logo_data = response.data;
                })
            } else if (this.companyLogo) {
                this.logo_data = {
                    logo_thumb: this.companyLogo.logo_thumbnail,
                    name: this.companyLogo.name,
                }
            }
        },
        methods: {}
    };
</script>
<style scoped>
    .avatar {
        margin-top: 3px;
        width: 200px;
        height: 200px;
        min-width: 36px;
        min-height: 36px;
        display: inline-block;
        background: #ccc;
        color: #222;
        margin-right: 5px;
        border-radius: 20px;
        float: left;
    }
</style>